export const stepNames = {
  BANK_ACCOUNT: 'bank_account',
  FIRST_STEPS_COMPLETED: 'first_steps_completed',
  LOGISTIC_ADDRESS: 'company_account',
  REGISTER_PRODUCT: 'first_product',
  SUBSCRIPTION: 'subscription_paid',
};

export const mixPanelEventTitles = {
  ONBOARDING: 'First steps - Viewed first steps page',
  ONBOARDING_STEPS_CARDS: {
    first_product: 'First steps - clicked on new product card',
    company_account: 'First steps - clicked on logistical address card',
    bank_account: 'First steps - clicked on receive for your sales card',
    subscription_paid: 'First steps - clicked on choose plan card',
  },
  ONBOARDING_STEPS_LINKS: {
    first_product: 'First steps - clicked on new product button',
    company_account: 'First steps - clicked on logistical address button',
    bank_account: 'First steps - clicked on receive for your sales button',
    subscription_paid: 'First steps - clicked on choose plan button',
  },
  BANK_ACCOUNT: '____ACHAR____',
};

export const CEF_CODE = '104';
